import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './modules/login/login.component';
import { MainComponent } from './pages/main/main.component';
import { AuthGuard } from './guards/auth.guard';
import { RegistrationComponent } from "./modules/registration/registration.component";
import { AuthExitGuard } from './guards/auth-exit.guard';
import { LoginPageGuard } from './guards/login-page.guard';
import { RequestComponent } from "./pages/request/request.component";
import { HelpComponent } from './pages/help/help.component';

const routes: Routes = [
  { path: '',
    pathMatch: 'full',
    component: MainComponent
  },
  { path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
    canActivate: [LoginPageGuard]
  },
  { path: 'chat',
    canActivate: [AuthGuard], // AuthGuard
    pathMatch: 'full',
    loadChildren: () => import('./modules/chat/chat.module').then(m => m.ChatModule)
  },
  // { path: 'login', pathMatch: 'full', component: LoginComponent, canActivate: [AuthExitGuard] },
  { path: 'registration', pathMatch: 'full', component: RegistrationComponent, canActivate: [AuthExitGuard] },
  { path: 'feedback', pathMatch: 'full', component: RequestComponent },
  { path: 'help', pathMatch: 'full', component: HelpComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {anchorScrolling: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
